/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-undef */
import * as React from "react";
import AppContext from "../Utils/appContext";
import { getAllCategories } from "../Utils/api-service";
import { divideCategories } from "../Utils/categories-divide";
import SubCategoryGridLevel3 from "../Components/SubCategoryGridLevel-3";

const SubCategoriesLevel3 = React.memo(() => {
  const {
    categories,
    setCategories,
    setSubCategories,
    setOtherCategories,
    setLevel3Categories,
  } = React.useContext(AppContext);
  React.useEffect(() => {
    if (categories.length === 0) {
      const res = getAllCategories();
      res.then((data) => {
        if (data.status === 200) {
          const {
            parentCategories,
            childCategories,
            thirdChildCategories,
            otherCategories,
          } = divideCategories(data.data?.collections.nodes);
          setCategories(parentCategories);
          setSubCategories(childCategories);
          setLevel3Categories(thirdChildCategories);
          setOtherCategories(otherCategories);
        }
      });
    }
  });

  React.useEffect(() => {
    $(".loader").fadeOut("slow");
    $(".loader").remove("slow");
  }, []);
  return (
    <>
      <div className="loader">
        <span></span>
        <span></span>
      </div>
      <section id="estimate-panel-space"></section>
      <SubCategoryGridLevel3 />
      <section className="panel-space"></section>
    </>
  );
});

export default SubCategoriesLevel3;
